/**
 * @param {number} id Id da alternativa
 * @returns Objeto contendo o grupo a que pertence, o id da pesquisa, id da pergunta e id da alternativa.
 */
export const getAlternativeIdentifiers = function(id) {
  const [groupId, surveyId, questionId, alternativeId] = id
    .split("_")
    .map((value) => !value.includes('-') ? Number(value) : value);

  return {
    groupId,
    surveyId,
    questionId,
    alternativeId,
  };
};
